module.exports = __webpack_public_path__ + "img/Ivy.93fcc07c.jpg";